import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Login/VERIFY_PUSH_ERROR',
    PENDING: 'Login/VERIFYL_PUSH_PENDING',
    SUCCESS: 'Login/VERIFYL_PUSH_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
